import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=e03b951c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e03b951c"]])

export default __exports__